import { useEffect, useRef, useState } from 'react';
import './FloatingAlert.scss';

const EXIT_DURATION_MS = 260;
const ENTER_DELAY_MS = 10;

const FloatingAlert = ({ message, type = 'danger', onClose }) => {
  const [isRendered, setIsRendered] = useState(!!message);
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const lastMessageRef = useRef(message);

  useEffect(() => {
    if (message) {
      lastMessageRef.current = message;
      setIsRendered(true);
      setIsClosing(false);
      const enterTimer = setTimeout(() => setIsVisible(true), ENTER_DELAY_MS);
      return () => clearTimeout(enterTimer);
    }

    if (!message && isRendered) {
      setIsClosing(true);
      setIsVisible(false);
      const exitTimer = setTimeout(() => {
        setIsRendered(false);
        setIsClosing(false);
      }, EXIT_DURATION_MS);
      return () => clearTimeout(exitTimer);
    }

    return undefined;
  }, [message, isRendered]);

  const handleClose = () => {
    if (isClosing) return;
    setIsClosing(true);
    setIsVisible(false);
    setTimeout(() => {
      setIsRendered(false);
      setIsClosing(false);
      if (onClose) onClose();
    }, EXIT_DURATION_MS);
  };

  if (!isRendered) return null;

  const displayMessage = message || lastMessageRef.current;

  return (
    <div
      className={[
        `alert-${type} alert-dismissible`,
        'floating-alert',
        isVisible ? 'is-visible' : '',
        isClosing ? 'is-closing' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      role='alert'
    >
      <span className='floating-alert__message'>{displayMessage}</span>

      {onClose && (
        <button
          type='button'
          className='btn-close'
          onClick={handleClose}
          aria-label='Cerrar'
        ></button>
      )}
    </div>
  );
};

export default FloatingAlert;
